import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore,Timestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY, // Replace with your Firebase API key,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN, // Replace with your Firebase auth domain,
  projectId:process.env.REACT_APP_FIREBASE_PROJECT_ID, // Replace with your Firebase project ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET, // Replace with your Firebase storage bucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID, // Replace with your Firebase messaging sender ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID, // Replace with your Firebase app ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, // Replace with your Firebase measurement ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);



export { auth, provider, db };